var href = location.href ;
var resetHeaderActivie = function(activeIndex){
    document.querySelectorAll(".j-nvs").forEach((item,index)=>{
        item.className = item.className.replace(/\scur/,"");
        if(activeIndex === index){
            item.className += " cur";
        }
    })
}
export default function(){

    if(/char\_detail/.test(location.href)){
        resetHeaderActivie(2);
        return ;
    }
    if(/37games.com\/xdhz\/index/.test(href)||/37games.com\/xdhz/.test(href)){
        resetHeaderActivie(0);
        return ;
    }
    if(/article\/list\/id/.test(href)||/article\/view\/id/.test(href)){
        resetHeaderActivie(1);
        return ;
    }
}